<template>
  <div class="custom-order">
    <Breadcrumb />
    <!-- 表格 -->
    <input
      v-show="false"
      type="file"
      id="fileUpload"
      name="file"
      @change="handleSaveFile"
    />
    <div
      style="overflow:hidden;position: fixed;bottom: 10px;padding: 10px; width: calc(100% - 275px);z-index: 100"
    >
      <el-button type="primary" @click="handleUpdate" style="float:right;"
        >更新到Tiktok</el-button
      >
    </div>

    <div class="table-body">
      <el-table
        :data="tableData"
        @selection-change="handleSelectionChange"
        border
      >
        <el-table-column
          type="selection"
          width="55"
          align="center"
        ></el-table-column>
        <el-table-column
          align="center"
          label="图片"
          width="90px"
          prop="designId"
        >
          <template slot-scope="scope">
            <div style="overflow:hidden;">
              <div>
                <el-tooltip placement="bottom" effect="light">
                  <div slot="content">
                    <img
                      :src="
                        scope.row.tiktokPic && scope.row.tiktokPic.length > 0
                          ? scope.row.tiktokPic[0].imageUrl
                          : ''
                      "
                      style="width:300px;height:300px;margin: 0 0 0 5px;"
                    />
                  </div>
                  <img
                    style="width:60px;height:60px;margin: 0 0 0 5px;"
                    :src="
                      scope.row.tiktokPic && scope.row.tiktokPic.length > 0
                        ? scope.row.tiktokPic[0].imageUrl
                        : ''
                    "
                  />
                </el-tooltip>
              </div>
              <div
                v-if="false"
                style="color:#4934b2;cursor:pointer;text-align:center;"
              >
                编辑
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="200"
          label="产品名称"
          align="center"
          prop="shopName"
        >
          <template slot="header">
            产品名称<br />(<span
              @click="handleShowCellDialog('productName', '产品名称')"
              class="primary-color pointer"
              >一键设置</span
            >)
          </template>
          <template slot-scope="scope">
            <span
              ><el-input
                type="textarea"
                size="small"
                :rows="3"
                v-model="scope.row.productName"
              ></el-input>
            </span>
          </template>
        </el-table-column>
        <el-table-column
          width="100"
          label="描述"
          align="center"
          prop="description"
        >
          <template slot="header">
            描述<br />(<span
              @click="handleShowCellDialog('description', '描述')"
              class="primary-color pointer"
              >一键设置</span
            >)
          </template>
          <template slot-scope="scope">
            <span
              @click="handleEditDesc(scope.row)"
              style="color:#4934b2;cursor:pointer;"
              >详情</span
            >
          </template>
        </el-table-column>
        <el-table-column width="100" label="品牌" align="center" prop="brand">
          <template slot="header">
            品牌
          </template>
          <template slot-scope="scope">
            <span>
              {{ scope.row.brand }}
              <div
                @click="handleEditBrand(scope.row)"
                style="color:#4934b2;cursor:pointer;text-align:center;"
              >
                设置
              </div>
            </span>
          </template>
        </el-table-column>
        <el-table-column
          label="变种信息"
          header-align="center"
          align="left"
          prop="color"
          width="125"
        >
          <template slot-scope="scope">
            <div style="line-height:36px;margin: 8px 0 0 0;">
              <div
                v-if="!scope.row.expand && index < 4"
                :title="scope.row.color"
                class="text-ellipsis"
                style="width:280px;margin: 0 0 0px 0;"
                v-for="(record, index) in scope.row.tiktokSku"
                :key="index"
              >
                {{ record.color }}, {{ record.size }}
              </div>
              <div
                v-if="scope.row.expand"
                :title="scope.row.color"
                class="text-ellipsis"
                style="width:280px;margin: 0 0 0 0;"
                v-for="(record, index) in scope.row.tiktokSku"
                :key="index"
              >
                {{ record.color }}, {{ record.size }}
              </div>
              <div v-if="scope.row.tiktokSku.length > 4">
                <span
                  @click="handleExpand(scope.row)"
                  style="color:#4934b2;cursor:pointer;"
                  >{{ scope.row.expand ? "收起" : "展开" }}</span
                >
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="SKU"
          header-align="center"
          align="center"
          prop="sellerSku"
          width="135"
        >
          <template slot="header">
            SKU<br />(<span
              @click="handleShowCellDialog('sellerSku', 'SKU')"
              class="primary-color pointer"
              >一键设置</span
            >)
          </template>
          <template slot-scope="scope">
            <div style="line-height:36px;margin: 8px 0 0 0;">
              <div
                v-if="!scope.row.expand && index < 4"
                :title="record.sellerSku"
                class="text-ellipsis"
                style="width:125px;"
                v-for="(record, index) in scope.row.tiktokSku"
                :key="index"
              >
                {{ record.sellerSku }}
              </div>
              <div
                v-if="scope.row.expand"
                :title="record.sellerSku"
                class="text-ellipsis"
                style="width:125px;"
                v-for="(record, index) in scope.row.tiktokSku"
                :key="index"
              >
                {{ record.sellerSku }}
              </div>
              <div v-if="scope.row.tiktokSku.length > 4">
                <span
                  @click="handleExpand(scope.row)"
                  style="color:#4934b2;cursor:pointer;"
                  >{{ scope.row.expand ? "收起" : "展开" }}</span
                >
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="价格"
          align="left"
          prop="originalPrice"
          width="95"
          header-align="center"
        >
          <template slot="header">
            价格<br />(<span
              @click="handleShowCellDialog('originalPrice', '价格')"
              class="primary-color pointer"
              >一键设置</span
            >)
          </template>
          <template slot-scope="scope">
            <div
              v-if="!scope.row.expand && index < 4"
              :title="record.originalPrice"
              class="text-ellipsis"
              v-for="(record, index) in scope.row.tiktokSku"
              :key="index"
              style="margin: 0 0 4px 0;"
            >
              <el-input
                style="width:72px;"
                size="small"
                v-model="record.originalPrice"
              ></el-input>
            </div>
            <div
              v-if="scope.row.expand"
              :title="record.originalPrice"
              class="text-ellipsis"
              v-for="(record, index) in scope.row.tiktokSku"
              :key="index"
              style="margin: 0 0 4px 0;"
            >
              <el-input
                style="width:72px;"
                size="small"
                v-model="record.originalPrice"
              ></el-input>
            </div>
            <div v-if="scope.row.tiktokSku.length > 4">
              <span
                @click="handleExpand(scope.row)"
                style="color:#4934b2;cursor:pointer;"
                >{{ scope.row.expand ? "收起" : "展开" }}</span
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="95"
          header-align="center"
          label="库存"
          prop="quantity"
        >
          <template slot="header">
            库存<br />(<span
              @click="handleShowCellDialog('stock', '库存')"
              class="primary-color pointer"
              >一键设置</span
            >)
          </template>
          <template slot-scope="scope">
            <div
              v-if="!scope.row.expand && index < 4"
              :title="scope.row.stock"
              class="text-ellipsis"
              v-for="(record, index) in scope.row.tiktokSku"
              :key="index"
              style="margin: 0 0 4px 0;"
            >
              <el-input
                style="width:72px;"
                size="small"
                v-model="record.stock"
              ></el-input>
            </div>
            <div
              v-if="scope.row.expand"
              :title="scope.row.stock"
              class="text-ellipsis"
              v-for="(record, index) in scope.row.tiktokSku"
              :key="index"
              style="margin: 0 0 4px 0;"
            >
              <el-input
                style="width:72px;"
                size="small"
                v-model="record.stock"
              ></el-input>
            </div>
            <div v-if="scope.row.tiktokSku.length > 4">
              <span
                @click="handleExpand(scope.row)"
                style="color:#4934b2;cursor:pointer;"
                >{{ scope.row.expand ? "收起" : "展开" }}</span
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="包装尺寸(cm)"
          header-align="center"
          align="left"
          prop="packageLength"
          width="195px"
        >
          <template slot="header">
            包装尺寸<br />(<span
              @click="handleShowCellDialog('packageLength', '包装尺寸')"
              class="primary-color pointer"
              >一键设置</span
            >)
          </template>
          <template slot-scope="scope">
            <el-input
              placeholder="长"
              style="width:50px;margin-right:4px;"
              size="small"
              v-model="scope.row.packageLength"
            ></el-input>
            <el-input
              placeholder="宽"
              style="width:50px;margin-right:4px;"
              size="small"
              v-model="scope.row.packageWidth"
            ></el-input>
            <el-input
              placeholder="高"
              style="width:50px"
              size="small"
              v-model="scope.row.packageHeight"
            ></el-input>
          </template>
        </el-table-column>

        <el-table-column
          label="重量(kg)"
          header-align="center"
          align="left"
          prop="packageWeight"
          width="95"
        >
          <template slot="header">
            重量<br />(<span
              @click="handleShowCellDialog('packageWeight', '重量')"
              class="primary-color pointer"
              >一键设置</span
            >)
          </template>
          <template slot-scope="scope">
            <el-input
              style="width:72px;margin: 0 0 4px 0;"
              size="small"
              v-model="scope.row.packageWeight"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column
          label="COD"
          header-align="center"
          align="center"
          prop="isCodOpen"
        >
          <template slot="header">
            COD<br />(<span
              @click="handleShowCellDialog('isCodOpen', 'COD')"
              class="primary-color pointer"
              >一键设置</span
            >)
          </template>
          <template slot-scope="scope">
            <a style="cursor:pointer;" @click="handleShowPreOrder(scope.row)"
              >{{ scope.row.isCodOpen == "02" ? "否" : "是" }}
            </a>
          </template>
        </el-table-column>

        <el-table-column
          header-align="center"
          fixed="right"
          label="操作"
          prop="size"
          width="100"
        >
          <template slot-scope="scope">
            <div class="operate">
              <span class="link" @click="handleDeleteProduct(scope.$index)">
                <i style="font-size: 16px;" class="el-icon-delete"></i>
              </span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog
      :close-on-click-modal="false"
      :title="dialogFormTitle"
      :visible.sync="dialogFormVisible"
      width="1280px"
    >
      <el-form
        :model="dialogForm"
        ref="noticeForm"
        class="notice-form"
        label-width="80px"
      >
        <el-form-item
          v-if="dialogFormTitle == '描述'"
          label="描述："
          prop="content"
        >
          <CKEditor4
            v-model="dialogForm.content"
            @getCkEditorInstance="getEditor"
            :config="editorConfig"
            @open="openUploadDialog"
          ></CKEditor4>
        </el-form-item>
        <el-form-item
          label="品牌："
          v-if="dialogFormTitle == '品牌'"
          prop="brand"
        >
          <el-select
            clearable
            filterable
            style="width: 300px"
            v-model="dialogForm.brandId"
            placeholder="请选择"
            class="input"
            size="small"
          >
            <el-option
              v-for="(value, index) in brandList"
              :key="index"
              :label="value.name"
              :value="value.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="dialogFormVisible = false"
          >取消</el-button
        >
        <el-button type="primary" size="small" @click="handleSaveDialog"
          >保存</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      title="COD"
      :visible.sync="preOrderVisible"
      width="600px"
    >
      <el-radio-group v-model="preOrderForm.isCodOpen">
        <el-radio label="02">否</el-radio>
        <el-radio label="01">是</el-radio> </el-radio-group
      ><br /><br />

      <div slot="footer">
        <el-button size="small" @click="preOrderVisible = false"
          >取消</el-button
        >
        <el-button type="primary" size="small" @click="handleSavePreOrder"
          >保存</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      :title="`编辑产品图`"
      :visible.sync="imageDialogVisible"
      width="1280px"
      ><div>
        <div class="variantInfo">
          <span class="mr_10 f_gray">SKU</span>{{ currentSku.sellerSku }}
          <span class="line"></span>
          <span class="mr_10 f_gray">变种</span>{{ currentSku.color }},
          {{ currentSku.size }}
        </div>
        <div>
          <ul
            class="extra-image-ul letter w70 detail-image-ul amazon sort-img active"
          >
            <draggable
              :list="picList"
              style="overflow: hidden"
              filter=".forbid"
              @start="drag = true"
              @end="drag = false"
              :move="onMove"
            >
              <li
                v-for="(record, index) in picList"
                :key="index"
                class="sort-img-item"
              >
                <el-tooltip placement="bottom" effect="light">
                  <div slot="content">
                    <img
                      style="width:300px;height:300px;"
                      :src="record.lazadaSkuPicUrl"
                    />
                  </div>
                  <img :src="record.lazadaSkuPicUrl" />
                </el-tooltip>
                <span class="first-pro-icon icon-corner-mark"></span>
                <div class="wish-product-img-ope">
                  <div style="width: 100%; overflow: hidden">
                    <a
                      @click.prevent="handleReplaceImage(picList, index)"
                      class="set-main"
                      style="margin: 0 40px 0 0"
                      >替换</a
                    >
                    <a
                      @click.prevent="hanldeDeleteImage(picList, index)"
                      class="set-main"
                      style="margin: 0 4px 0 0"
                      >移除</a
                    >
                  </div>
                </div>
              </li>
              <li
                @click="handleUploadImage(key)"
                v-if="picList && picList.length < 9"
                class="sort-img-item add-image-button forbid"
              >
                <p><i class="el-icon-plus"></i></p>
              </li>
            </draggable>
          </ul>
        </div>
      </div>
      <div slot="footer">
        <el-button size="small" @click="imageDialogVisible = false"
          >取消</el-button
        >
        <el-button type="primary" size="small" @click="handleSaveImage"
          >保存</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :title="`修改${cellTitle}`"
      :visible.sync="showCellDialog"
      width="580px"
      @close="handleCloseCellDialog"
    >
      <el-row style="margin-top: 15px; margin-left: 15px">
        <span style="display: inline-block;float:left;margin: 4px 0 0 0;"
          >{{ cellTitle }}：</span
        >
        <span
          v-if="cellType == 'packageLength'"
          class="text-ellipsis"
          style="width:280px;display: inline-block;float:left;"
        >
          <el-input
            placeholder="长"
            style="width:50px;margin-right:4px;"
            size="small"
            v-model="cellForm.packageLength"
          ></el-input>
          <el-input
            placeholder="宽"
            style="width:50px;margin-right:4px;"
            size="small"
            v-model="cellForm.packageWidth"
          ></el-input>
          <el-input
            placeholder="高"
            style="width:50px"
            size="small"
            v-model="cellForm.packageHeight"
          ></el-input>
        </span>
        <span v-else-if="cellType == 'isCodOpen'">
          <el-radio-group v-model="preOrderForm.isCodOpen">
            <el-radio label="02">否</el-radio>
            <el-radio label="01">是</el-radio>
          </el-radio-group>
        </span>
        <span v-else-if="cellType == 'status'">
          <el-switch v-model="cellValue"></el-switch>
        </span>
        <el-input
          v-else
          v-model.trim="cellValue"
          :title="`请输入${cellTitle}`"
          size="mini"
          style="width: 450px;float:left;"
        ></el-input>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCloseCellDialog" size="small">取 消</el-button>
        <el-button type="primary" @click="handleUpdateCell" size="small"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <LocalUpload :ckData="localUploadData"></LocalUpload>
    <OnlineUpload :ckData="onlineUploadData"></OnlineUpload>
  </div>
</template>

<script>
import Breadcrumb from "@/components/common/Breadcrumb"
import LoanTip from "./components/LoanTip"
import EditOrder from "./components/EditOrder"
import SyncOrder from "./components/SyncOrder"
import ExchangeDialog from "./components/ExchangeDialog"
import ServiceDialog from "./components/ServiceDialog"
import sendDialog from "./components/SetSendTime"
import RemarkDialog from "./components/RemarkDialog"
import EditSale from "./components/EditSale"
import CopyOrder from "./components/CopyOrder"
import AuditOrder from "./components/AuditOrder"
import AcceptOrder from "./components/AcceptOrder"
import SendOrderFlb from "./components/SendOrderFlb"
import CancelDialog from "./components/CancelOrder"
import { selectExpreList, getExpreProcess } from "@/api/order/all"
import { batchUpdate } from "@/api/order/tiktok"
import { mapGetters } from "vuex"
import dayjs from "dayjs"
import {
  orderList,
  getOrderDetail,
  cancelOrder,
  recoveryOrder,
  orderToCopy,
  createShip,
  exportExcel,
  uploadTb,
  getDesignInfo,
} from "@/api/order/all"
import CKEditor4 from "@/components/common/CKEditor"
import LocalUpload from "@/components/common/ckEditorUploadPage/localUpload"
import OnlineUpload from "@/components/common/ckEditorUploadPage/onlineUpload"
import {
  getProductList,
  syncByShop,
  productOn,
  productOff,
} from "@/api/order/lazada"
import { getShipMethod } from "@/api/product/shipMethod"
import { getOSSToken } from "@/api/setting"
import { getShopList } from "@/api/system/shopManage"
import noImage from "@/assets/images/no_image.png"
import SelectShip from "./components/SelectShip"
import qs from "qs"
import { downLoadExcel } from "@/utils/zipdownload"
import ExpreDetail from "./components/ExpreDetail"
import { listSubAccount } from "@/api/system/user"
import { listUser } from "@/api/business/merchantManage"
import draggable from "vuedraggable"
import { getBrand } from "@/api/order/tiktok"

export default {
  name: "editProductShopee",
  components: {
    Breadcrumb,
    SyncOrder,
    LoanTip,
    ExchangeDialog,
    ServiceDialog,
    sendDialog,
    EditOrder,
    RemarkDialog,
    EditSale,
    AuditOrder,
    SelectShip,
    SendOrderFlb,
    ExpreDetail,
    CancelDialog,
    AcceptOrder,
    CKEditor4,
    draggable,
    LocalUpload,
    OnlineUpload,
  },
  data() {
    return {
      preOrderVisible: false,
      shopList: [],
      shopListClone: [],
      noImage: noImage,
      form: {
        shopId: [],
        productName: "",
        sellerSku: "",
        operNo: "",
        createTime: [],
        pageNum: 1,
        pageSize: 30,
      },
      dialogForm: {
        content: "",
        brand: "",
        brandId: "",
      },
      cellForm: {
        packageWidth: "",
        packageHeight: "",
        packageLength: "",
        specialTime: [],
      },
      currentRow: {},
      currentSku: {},
      picList: [],
      aliyunOssToken: {},
      dialogFormVisible: false,
      dialogFormTitle: "",
      rules: {
        file: [{ required: true, message: "请选择文件", trigger: "change" }],
      },
      previewImagesVisible: false,
      productImageList: [],
      importForm: {
        appId: "",
        file: null,
      },
      preOrderForm: {
        isCodOpen: "0",
      },
      imageForm: {},
      activeCarousel: 0,
      showUploadLabel: false,
      cancelOrderVisible: false, //取消订单弹框
      modalTitle: "",
      modalText: "",
      statusText: "",
      statusMap: null,
      total: 0,
      tableData: [], // 表格数据
      multipleSelection: [], // 选中列表数据
      showSyncOrder: false,
      showService: false,
      showExchange: false,
      showCancel: false,
      showEdit: false,
      showRemark: false,
      showShip: false,
      showCopy: false,
      showSendOrder: false,
      showEditSale: false,
      showAuditOrder: false,
      showAcceptOrder: false,
      currentOrder: {},
      currentAppId: "",
      orderCanEdit: true,
      roles: [],
      shipList: [],
      isCheckShop: true,
      isCheckStatus: true,
      scrollMenu: null,
      objectHeight: null,
      expreList: [],
      expreDetail: {},
      expreVisible: false,
      isExpand: false,
      shopName: "",
      isExpandUser: false,
      nickName: "",
      isCheckUser: true,
      userList: [],
      activeName: "on",
      accountList: [],
      detailVisible: false,
      imageDialogVisible: false,
      showSendTime: false,
      productList: [],
      dialogTitle: "效果图",
      isExpandShop: false,
      showCellDialog: false,
      cellTitle: "",
      cellName: "",
      cellValue: "",
      cellType: "",
      editor: null,
      brandList: [],
      currentImageIndex: 0,
      editorConfig: {
        allowedContent: true, //设置为true，以防止CKEditor 4删除不允许的元素
        extraPlugins: ["uploadImg"],
        height: "300px",
        toolbar: [
          ["Maximize"],
          ["Bold", "Italic", "Underline", "Strike"],
          ["TextColor", "BGColor"],
          [
            "JustifyLeft",
            "JustifyCenter",
            "JustifyRight",
            "JustifyBlock",
            "-",
            "NumberedList",
            "BulletedList",
            "-",
            "Outdent",
            "Indent",
            "-",
            "Subscript",
            "Superscript",
          ],
          ["HorizontalRule", "RemoveFormat"],
          ["Undo", "Redo"],
          "/",
          ["Styles", "Format", "Font", "FontSize"],
          ["Table"],
          ["uploadImg"],
        ],
        language: "zh-cn",
        wordcount: {
          showCharCount: true,
        },
      },
      localUploadData: {
        visible: false,
        editor: null,
      },
      onlineUploadData: {
        visible: false,
        editor: null,
      },
    }
  },
  computed: {
    ...mapGetters(["dictData", "dictMap", "user"]),
    rowSelectNum() {
      return this.multipleSelection.length
    },
    showPayButton() {
      let permission = JSON.stringify(this.$store.state.permission)
      return permission.indexOf("GetPay") !== -1
    },
    orderWidth() {
      let width = document.body.clientWidth
      let orderWidth = "476"
      if (width > 1500) {
        orderWidth = "476"
      } else {
        orderWidth = "339"
      }
      return orderWidth
    },
    tdWidth() {
      let width = document.body.clientWidth
      let orderWidth = "200"
      if (width > 1400) {
        orderWidth = "189"
      } else {
        orderWidth = "129"
      }
      return orderWidth
    },
  },
  mounted() {
    let appNo = this.$route.query.appNo
    if (appNo) {
      this.form.appNo = appNo
      this.form.createTime = []
    }
    let status = this.$route.query.status
    if (status) {
      this.activeName = status
    }
    let products = this.$route.params.products
    for (let record of products) {
      record.expand = false
      for (let sku of record.tiktokSku) {
        sku.status = true
      }
    }
    this.tableData = products

    this.getShops()
    // this.getData()
    this.getShip()
    this.getUserList()
    this.getAccountList()

    this.roles = this.user.roles
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll)
  },
  methods: {
    handleShowMaps(row) {
      this.productImageList = []
      for (let record of row.maps) {
        this.productImageList.push(record.picUrl)
      }
      this.dialogTitle = "图片预览"
      this.previewImagesVisible = true
    },
    async handleShowDesignMaps(row) {
      this.productImageList = []
      let result = await getDesignInfo(row.designId)
      for (let record of result.data.tiktokSku) {
        this.productImageList.push(record.mainPic.picUrl)
      }
      this.dialogTitle = "效果图预览"
      this.previewImagesVisible = true
    },
    handleUpdateSpecialTime() {
      this.tableData = this._.clone(this.tableData)
    },
    async getAccountList() {
      let result = await listUser({
        pageNum: 1,
        pageSize: 100000,
        userType: "01",
      })
      this.accountList = result.rows
    },
    handleClickTab() {},
    handleCloseExpre() {
      this.expreVisible = false
    },
    getShops() {
      getShopList({ platNo: "03", authStatus: "02" }).then((res) => {
        this.shopList = res.rows
        this.shopListClone = this._.clone(res.rows)
      })
    },
    getOssToken() {
      var _self = this
      getOSSToken()
        .then(function(res) {
          if (res.code == 200) {
            _self.aliyunOssToken = res.data
          } else {
            _self.$message.error(res.msg)
          }
        })
        .catch(function(error) {
          console.log(error)
        })
    },
    async productOff(row) {
      try {
        this.$confirm("确定下架吗", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(async () => {
            this.startLoading()
            await productOff({ pIds: row.pId })
            this.$message.success("下架成功！")
            this.getData()
          })
          .catch(() => {})
          .finally(() => {
            this.endLoading()
          })
      } catch (error) {}
    },
    handleEditDesc(row) {
      this.dialogFormVisible = true
      this.currentRow = row
      this.dialogForm.content = row.description
      this.dialogFormTitle = "描述"
    },
    async handleEditBrand(row) {
      this.dialogFormVisible = true
      this.currentRow = row
      this.dialogFormTitle = "品牌"
      this.dialogForm.brandId = ""
      this.dialogForm.brand = ""
      //获取品牌
      let result = await getBrand({
        shopId: row.shopId,
        categoryId: row.categoryId,
      })
      this.brandList = result.data
      this.brandList.unshift({ id: "", name: "无品牌" })
    },
    handleShowPreOrder(row) {
      this.preOrderVisible = true
      this.currentRow = row
      this.preOrderForm = this._.clone(row)
    },
    handleEditImage(row, sku) {
      this.imageDialogVisible = true
      this.currentRow = row
      this.currentSku = sku
      this.picList = sku.picList
      this.getOssToken()
    },
    handleChangeEditor(value) {
      this.dialogForm.content = value
    },
    hanldeDeleteImage(list, index) {
      list.splice(index, 1)
    },
    handleReplaceImage(list, index) {
      this.currentImageIndex = index
      document.querySelector("#fileUpload").click()
    },
    handleSaveFile() {
      var _self = this
      var getSuffix = function(fileName) {
        var pos = fileName.lastIndexOf(".")
        var suffix = ""
        if (pos != -1) {
          suffix = fileName.substring(pos)
        }
        return suffix
      }

      var file = $("#fileUpload").val()
      if (file.length == 0) {
        alert("请选择文件")
      }

      var filename = new Date().getTime() + getSuffix(file)
      var formData = new FormData()

      //注意formData里append添加的键的大小写
      formData.append("key", _self.aliyunOssToken.dir + filename) //存储在oss的文件路径
      formData.append("OSSAccessKeyId", _self.aliyunOssToken.accessid) //accessKeyId
      formData.append("policy", _self.aliyunOssToken.policy) //policy
      formData.append("Signature", _self.aliyunOssToken.signature) //签名
      //如果是base64文件，那么直接把base64字符串转成blob对象进行上传就可以了

      formData.append("file", $("#fileUpload")[0].files[0])
      formData.append("success_action_status", 200) //成功后返回的操作码
      this.domain = _self.aliyunOssToken.host + "/"

      var url = _self.aliyunOssToken.host
      var fileUrl =
        _self.aliyunOssToken.host + "/" + _self.aliyunOssToken.dir + filename
      $.ajax({
        url: url,
        type: "POST",
        data: formData,
        // async: false,
        cache: false,
        contentType: false,
        processData: false,
        success: function(data) {
          if (_self.currentImageIndex == -1) {
            _self.picList.push({
              lazadaSkuPicUrl: fileUrl,
            })
          } else {
            _self.picList[_self.currentImageIndex].lazadaSkuPicUrl = fileUrl
          }

          let array = JSON.parse(JSON.stringify(_self.picList))
          _self.picList = array
          $("#fileUpload").val(null)
        },
        error: function(data) {
          $("#fileUpload").val(null)
        },
      })
    },
    async productOn(row) {
      try {
        this.$confirm("确定上架吗", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(async () => {
            this.startLoading()
            await productOn({ pIds: row.pId })
            this.$message.success("上架成功！")
            this.getData()
          })
          .catch(() => {})
          .finally(() => {
            this.endLoading()
          })
      } catch (error) {}
    },
    async handleUpdate() {
      try {
        if(this.multipleSelection.length == 0){
          this.msgError('请选择数据')
          return
        }
        let data = JSON.parse(JSON.stringify(this.multipleSelection))

        this.startLoading()

        for (let record of data) {
          let tiktokSku = []
          let deleteModel = []
          for (let sku of record.tiktokSku) {
            if (!sku.status) {
              deleteModel.push(sku.modelId)
            } else {
              sku.status = "active"
              tiktokSku.push(sku)
            }
          }
          record.tiktokSku = tiktokSku
          record.deleteModel = deleteModel.join(",")
        }

        let result = await batchUpdate(data)
        this.endLoading()
        this.msgSuccess("批量编辑成功")
        this.$router.push({
          path: "/carry/tiktok/onlineProductTiktok",
        })
      } catch (error) {
        console.log(error)
      }
    },
    handleUpdateCell() {
      for (let record of this.tableData) {
        if (
          this.cellType == "stock" ||
          this.cellType == "currentPrice" ||
          this.cellType == "sellerSku" ||
          this.cellType == "status" ||
          this.cellType == "originalPrice"
        ) {
          for (let sku of record.tiktokSku) {
            sku[this.cellType] = this.cellValue
          }
        } else if (this.cellType == "packageLength") {
          record["packageLength"] = this.cellForm.packageLength
          record["packageWidth"] = this.cellForm.packageWidth
          record["packageHeight"] = this.cellForm.packageHeight
        } else if (this.cellType == "isCodOpen") {
          record["isCodOpen"] = this.preOrderForm.isCodOpen
        } else {
          record[this.cellType] = this.cellValue
        }
      }
      this.tableData = JSON.parse(JSON.stringify(this.tableData))
      this.showCellDialog = false
    },
    handleChangeShop() {
      this.form.shopId = []
      if (this.isCheckShop) {
        this.shopList.map((record) => {
          this.form.shopId.push(record.shopId)
        })
      }
    },
    handleChangeStatus() {
      this.form.orderStatus = []
      if (this.isCheckStatus) {
        this.dictData["order_status"].map((record) => {
          this.form.orderStatus.push(record.value)
        })
      }
    },
    getShip() {
      getShipMethod().then((res) => {
        this.shipList = res.rows
      })
    },
    getUserList() {
      listSubAccount({}).then((res) => {
        res.rows.unshift({
          userName: this.user.name,
          nickName: this.user.nickName ? this.user.nickName : this.user.name,
        })
        this.userList = res.rows
      })
    },
    handleChangeUser() {
      this.form.operNos = []
      let shopList = this._.clone(this.shopListClone)
      if (this.isCheckUser) {
        this.userList.map((record) => {
          this.form.operNos.push(record.userName)
        })
        this.shopList = shopList
      } else {
        this.shopList = shopList.filter((shop) => {
          for (let record of this.form.operNos) {
            if (record == shop.operNo) {
              return true
            }
          }
          return false
        })
      }
      this.form.shopId = []
    },

    getProducingDay(date) {
      return (
        Math.floor(((new Date() - new Date(date)) / 1000 / 60 / 60 / 24) * 10) /
        10
      )
    },
    handleChangeShop() {
      this.form.shopId = []
      if (this.isCheckShop) {
        this.shopList.map((record) => {
          this.form.shopId.push(record.shopId)
        })
      }
    },
    getShopList() {
      getShopList().then((res) => {
        this.shopList = res.rows
        let options = [
          {
            value: "amazon",
            label: "亚马逊店铺",
            children: [],
          },
          {
            value: "lazada",
            label: "lazada店铺",
            children: [],
          },
          {
            value: "other",
            label: "其他店铺",
            children: [],
          },
        ]
        res.rows.map((record) => {
          if (record.platNo == "04") {
            options[0].children.push({
              value: record.shopId,
              label: record.shopName,
            })
          } else if (record.platNo == "03") {
            options[1].children.push({
              value: record.shopId,
              label: record.shopName,
            })
          } else {
            options[2].children.push({
              value: record.shopId,
              label: record.shopName,
            })
          }
        })

        if (this.importType == "amazon") {
          options.splice(1, 1)
        } else if (this.importType == "lazada") {
          options.splice(0, 1)
        }
        this.options = options
      })
    },
    async getBrand() {},
    handleSaveDialog() {
      if (this.dialogFormTitle == "描述") {
        this.currentRow.description = this.editor.getData()
      } else if (this.dialogFormTitle == "品牌") {
        this.currentRow.brandId = this.dialogForm.brandId
        for (let record of this.brandList) {
          if (record.id == this.currentRow.brandId) {
            this.currentRow.brand = record.name
            break
          }
        }
      }
      this.dialogFormVisible = false
    },

    handleSavePreOrder() {
      this.currentRow.isCodOpen = this.preOrderForm.isCodOpen
      this.preOrderVisible = false
    },
    handleSaveImage() {
      this.currentSku.picList = this.picList
      this.imageDialogVisible = false
    },
    handleDeleteProduct(index) {
      this.tableData.splice(index, 1)
    },
    handleUploadImage(color) {
      this.currentImageIndex = -1
      document.querySelector("#fileUpload").click()
    },
    handleChangeOper() {
      let shopList = this._.clone(this.shopListClone)
      this.shopList = shopList.filter((shop) => {
        if (this.form.operNos.includes(this.user.name)) {
          return true
        }
        for (let record of this.userList) {
          if (this.form.operNos.includes(record.userName)) {
            for (let item of record.shops) {
              if (item.shopId == shop.shopId) {
                return true
              }
            }
          }
        }
        return false
      })

      this.form.shopId = []
      if (this.form.operNos.length == 0 && this.isCheckUser) {
        this.shopList = this._.clone(this.shopListClone)
      }
    },

    // 搜索
    getData() {
      let params = Object.assign({}, this.form)

      if (this.form.createTime && this.form.createTime.length > 0) {
        params["beginTime"] = dayjs(this.form.createTime[0]).format(
          "YYYY-MM-DD"
        )
        params["endTime"] = dayjs(this.form.createTime[1]).format("YYYY-MM-DD")
      }

      params.shopIds = params.shopId.join(",")

      delete params["createTime"]
      delete params["lineTime"]
      delete params["sendTime"]
      delete params["shopId"]

      if (this.activeName == "on") {
        params.status = "active"
        params.quantity = undefined
      } else if (this.activeName == "clear") {
        params.status = "0"
        params.quantity = 0
      } else if (this.activeName == "off") {
        params.status = "inactive"
        params.quantity = undefined
      }

      this.startLoading()
      getProductList(params)
        .then((res) => {
          if (res.code !== 200) {
            this.$message.error("获取订单列表失败")
          } else {
            this.total = res.total
            for (let record of res.rows) {
              record.expand = false
              for (let sku of record.tiktokSku) {
                try {
                  sku.status = true
                } catch (error) {}
              }
            }
            this.tableData = res.rows
          }
          this.endLoading()
        })
        .catch(() => {
          this.endLoading()
        })
    },
    handleCloseCellDialog() {
      this.showCellDialog = false
    },
    handleSelectShip(row) {
      this.currentOrder = row
      this.showShip = true
    },
    // 重置
    reset() {
      this.form = {
        platNo: "", // 平台渠道
        amazonSite: "", // 来源国家
        productType: "", // 产品类型
        matchType: "", // 匹配类型
        orderSource: "", // 订单来源
        createTime: [], // 创建时间
        lineTime: [], // 支付时间
        sendTime: [], // 发货时间
        shopId: [], // 店铺名称
        appNo: "", // 订单编号
        trackingNumber: "", // 物流单号
        orderStatus: [], // 订单状态
        pOperNo: "", //商家账号
        shippingMethod: "", //物流方式
        pageNum: 1,
        pageSize: 10,
      }
    },
    copyText(text) {
      let target = document.createElement("input") //创建input节点
      target.value = text // 给input的value赋值
      document.body.appendChild(target)
      target.value = text // 修改文本框的内容
      target.select() // 选中文本
      document.execCommand("copy") // 执行浏览器复制命令
      this.msgSuccess("复制成功")
      document.body.removeChild(target)
    },
    // 列表选择
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    handleShowCellDialog(cellType, cellTitle) {
      this.cellValue = ""
      this.cellForm = {
        packageWidth: "",
        packageHeight: "",
        packageLength: "",
      }
      this.preOrderForm = {
        isCodOpen: "01",
      }

      this.showCellDialog = true
      this.cellType = cellType
      this.cellTitle = cellTitle
    },
    GetOrderStatus(orderStatus) {
      if (orderStatus == "排单中") {
        return "待接单"
      }
      return orderStatus
    },
    syncOrder() {
      this.showSyncOrder = true
    },
    hideSyncOrder() {
      this.showSyncOrder = false
    },
    exchange() {
      this.showExchange = true
    },
    hideExchange() {
      this.showExchange = false
    },
    hideCancel() {
      this.showCancel = false
    },
    okEditExchange() {
      this.getData()
      this.showExchange = false
    },
    okEditCancel() {
      this.getData()
      this.showCancel = false
    },
    service() {
      this.showService = true
    },
    hideService() {
      this.showService = false
    },
    showAudit(data) {
      this.currentOrder = data
      this.showAuditOrder = true
    },
    showAccept(data) {
      this.currentOrder = data
      this.showAcceptOrder = true
    },
    handleShowSendOrder(data) {
      this.currentOrder = data
      this.showSendOrder = true
    },
    hideAuditOrder() {
      this.showAuditOrder = false
    },
    hideAcceptOrder() {
      this.showAcceptOrder = false
    },
    okEditService() {
      this.getData()
      this.showService = false
    },
    hideSendTime() {
      this.showSendTime = false
    },
    okEditSendTime() {
      this.getData()
      this.showSendTime = false
    },
    handleShowSendTime(data) {
      this.currentOrder = data
      this.showSendTime = true
      let a = 1
    },
    showOrderDetail(data) {
      getOrderDetail(data.appId).then((res) => {
        if (!res.data.addr) {
          res.data.addr = {}
        }
        this.currentOrder = res.data
        this.currentAppId = data.appId
        this.showEdit = true
        this.orderCanEdit = false
      })
    },
    handleCommand(command) {
      if (command == "exchange") {
        this.showExchange = true
      } else if (command == "service") {
        this.showService = true
      }
    },
    // 编辑订单
    edit(data) {
      getOrderDetail(data.appId).then((res) => {
        if (!res.data.addr) {
          res.data.addr = {}
        }
        this.currentOrder = res.data
        this.currentAppId = data.appId
        this.showEdit = true
        this.orderCanEdit = true
      })
    },
    hideEdit() {
      this.getData()
      this.showEdit = false
    },
    onUpdateFinish(appId) {
      if (appId) {
        getOrderDetail(appId).then((res) => {
          this.currentOrder = res.data
        })
      }
    },
    remark() {
      this.showRemark = true
    },
    hideRemark() {
      this.showRemark = false
    },
    hideShip() {
      this.showShip = false
      this.getData()
    },
    goReview() {
      const ids = []
      const orderStatusArray = []
      let shipFlag = true

      this.multipleSelection.map((el) => {
        ids.push(el.appNo)
        orderStatusArray.push(el.orderStatus)
        if (!(el.expre && el.expre.shippingMethod)) {
          shipFlag = false
        }
      })

      if (orderStatusArray.length == 0) {
        this.$message.error("请选择订单")
        return false
      }

      for (let record of orderStatusArray) {
        if (record != "02") {
          this.$message.info("只有已付款的订单才能审核")
          return false
        }
      }
      this.currentOrder = {
        appNo: ids.join(","),
      }
      this.showAuditOrder = true
    },
    hideSendOrder() {
      this.showSendOrder = false
      this.getData()
    },
    handleClickPreviewImage(index) {
      this.$refs["carouselPreview"].setActiveItem(index)
      this.activeCarousel = index
    },
    getEditor(editor) {
      this.editor = this.localUploadData.editor = this.onlineUploadData.editor = editor
    },
    updateTableData() {
      this.tableData = JSON.parse(JSON.stringify(this.tableData))
    },
    openUploadDialog(val) {
      if (val == "local") {
        this.localUploadData.visible = true
      } else if (val == "online") {
        this.onlineUploadData.visible = true
      }
    },
    // 复制订单
    copy(data) {
      orderToCopy(data.appId).then((res) => {
        if (!res.data.addr) {
          res.data.addr = {}
        }
        this.currentOrder = res.data
        this.currentAppId = data.appId
        this.showCopy = true
      })
    },
    hideCopy() {
      this.showCopy = false
    },
    showSale(data) {
      this.currentOrder = data
      this.showEditSale = true
    },
    hideEditSale() {
      this.showEditSale = false
    },
    okEditSale() {
      this.getData()
      this.showEditSale = false
    },
    okCopyOrder() {
      this.getData()
      this.showCopy = false
    },
    okAuditOrder() {
      this.getData()
      this.showAuditOrder = false
    },
    okAcceptOrder() {
      this.getData()
      this.showAcceptOrder = false
    },
    exportOrder() {
      let params = Object.assign({}, this.form)
      params.orderStatus = params.orderStatus.join(",")
      let ids = []
      this.multipleSelection.map((el) => {
        ids.push(el.appNo)
      })
      if (ids.length > 0) {
        params.appNos = ids.join(",")
      }

      if (this.form.createTime && this.form.createTime.length > 0) {
        params["beginTime"] = dayjs(this.form.createTime[0]).format(
          "YYYY-MM-DD"
        )
        params["endTime"] = dayjs(this.form.createTime[1]).format("YYYY-MM-DD")
      }

      if (this.form.lineTime && this.form.lineTime.length > 0) {
        params["lineTimeBegin"] = dayjs(this.form.lineTime[0]).format(
          "YYYY-MM-DD"
        )
        params["lineTimeEnd"] = dayjs(this.form.lineTime[1]).format(
          "YYYY-MM-DD"
        )
      }

      if (this.form.sendTime && this.form.sendTime.length > 0) {
        params["sendTimeBegin"] = dayjs(this.form.sendTime[0]).format(
          "YYYY-MM-DD"
        )
        params["sendTimeEnd"] = dayjs(this.form.sendTime[1]).format(
          "YYYY-MM-DD"
        )
      }

      delete params["createTime"]
      delete params["lineTime"]
      delete params["sendTime"]
      delete params["pageNum"]
      delete params["pageSize"]
      downLoadExcel(
        `/server/order/export?${qs.stringify(params)}&fileName=` +
          Math.random(),
        Math.random()
      )
    },
    // 取消订单
    cancelOrderFn(data) {
      this.$confirm("请确认是否取消订单？", "取消订单", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        cancelOrder({
          appId: data.appId,
        }).then((res) => {
          if (res.code !== 200) {
            this.$message.error("取消失败")
          } else {
            this.getData()
            this.$message({
              type: "success",
              message: "取消成功!",
            })
          }
        })
      })
    },
    async handleQuickOrder(row) {
      try {
        this.$confirm("请确认是否加急订单？", "加急订单", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(async () => {
          this.startLoading()
          let result = await createShip({ appId: row.appId })
          this.$message({
            type: "success",
            message: result.msg,
          })
          this.getData()
          this.endLoading()
        })
      } catch (error) {
        this.endLoading()
      }
    },
    async handleRefund(row) {
      try {
        this.$confirm("请确认是否取消订单？", "取消订单", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.currentOrder = row
          this.showCancel = true
        })
      } catch (error) {
        this.endLoading()
      }
    },
    // 恢复订单
    renewOrder(data) {
      this.$confirm("请确认是否恢复订单？", "恢复订单", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        recoveryOrder({
          appId: data.appId,
        }).then((res) => {
          if (res.code !== 200) {
            this.$message.error("恢复失败")
          } else {
            this.getData()
            this.$message({
              type: "success",
              message: "恢复成功!",
            })
          }
        })
      })
    },
    handleOpenDetail(row) {
      let routeUrl = this.$router.resolve({
        path: "/select/custom/product",
        query: { pId: row.pId, designId: row.designId },
      })
      window.open(routeUrl.href, "_blank")
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 1) {
        if (row.isNew && row.count != 0) {
          return {
            rowspan: row.count,
            colspan: 1,
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          }
        }
      }
    },
    batchDownload() {
      //判断是否有支付权限
      if (this.multipleSelection.length == 0) {
        this.msgError("请选择订单")
        return
      }

      const ids = []
      this.multipleSelection.map((el) => {
        ids.push(el.appNo)
      })
      let routeUrl = this.$router.resolve({
        path: "/prod-api/server/order/downloadImage",
        query: { appNos: ids.join(",") },
      })
      window.open(routeUrl.href, "_blank")
    },
    getHourHint(s1) {
      if (s1) {
        var reDate = /\d{4}-\d{1,2}-\d{1,2} /
        s1 = new Date(
          (reDate.test(s1) ? s1 : "2018-1-1 " + s1).replace(/-/g, "/")
        )
        let s2 = new Date()
        var ms = Math.round((s1.getTime() - s2.getTime()) / 1000 / 60 / 60)
        if (ms >= 0 && ms <= 12) {
          return "将在" + ms + "小时后过期"
        } else {
          return "已过期" + ms + "小时"
        }
      } else {
        return ""
      }
    },
    goRelate(data) {
      this.$router.push({
        path: "/order/order_aid/toMatchOrder",
        query: {
          appNo: data.appNo,
        },
      })
    },
    handleShowUploadLabel(row) {
      this.importForm.appId = row.appId
      this.$refs.inputer ? (this.$refs.inputer.value = "") : ""
      this.showUploadLabel = true
    },
    uploadFn() {
      let inputDOM = this.$refs.inputer
      let file = inputDOM.files

      this.importForm.file = file
    },
    handleUploadLabel() {
      this.$refs["importForm"].validate((valid) => {
        this.startLoading()
        let formData = new FormData()

        formData.append("file", this.importForm.file[0])
        formData.append("appId", this.importForm.appId)

        uploadTb(formData)
          .then((res) => {
            if (res.code !== 200) {
              this.$message.error("上传失败")
            } else {
              this.$message.success("上传成功")
              this.showModal = false
              // this.successOrder = res.rows
              this.showUploadLabel = false
              this.getData()
            }
            this.endLoading()
          })
          .catch(() => {
            this.endLoading()
          })
      })
    },
    handleShowDetail(record) {
      this.productList = record.shipList
      this.detailVisible = true
    },
    handleCloseDetail() {
      this.detailVisible = false
    },
    onMove(e) {
      if (!e.relatedContext.element) {
        return false
      }
      if (e.relatedContext.element.isMain) {
        return false
      }
      return true
    },
    handleOpenProduct(row) {
      let routeUrl = ""
      if (row.productType == "01") {
        routeUrl = this.$router.resolve({
          path: "/select/custom/product",
          query: { designId: row.designId },
        })
      } else {
        routeUrl = this.$router.resolve({
          path: "/select/custom/product",
          query: { pId: row.pId },
        })
      }

      window.open(routeUrl.href, "_blank")
    },
    caculateProduct(data) {
      let count = 0
      for (let record of data) {
        count += Number(record.num)
      }
      return count
    },
    handleExpand(row) {
      row.expand = !row.expand
      row.tiktokSku = this._.clone(row.tiktokSku)
    },
    handleCheckAll() {
      this.form.shopId = []
      for (let record of this.shopList) {
        this.form.shopId.push(record.shopId)
      }
    },
    throttle(fn, wait) {
      var pre = Date.now()
      return function() {
        var context = this
        var args = arguments
        var now = Date.now()
        if (now - pre >= wait) {
          fn.apply(context, args)
          pre = Date.now()
        }
      }
    },
    handleScroll() {
      var menu = this.scrollMenu
      //获取页面的滚动距离
      var scrollHeight =
        document.documentElement.scrollTop || document.body.scrollTop
      //滚动到一定位置 div固定到顶部 js实现吸顶
      if (this.objectHeight < scrollHeight) {
        menu.style.position = "fixed"
        menu.style.top = 0
        menu.style.width = "calc(100% - 290px)"
        menu.style.padding = "8px 0"
      } else {
        menu.style.position = "relative"
        menu.style.width = "100%"
        menu.style.padding = "0"
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.form-body {
  padding: 10px 20px;
}

.form-body .item {
  min-height: 42px;
}

.form-body .item.right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.table-body {
  margin-top: 10px;
  border: 1px solid #ebeef5;
  background: #fff;
  font-size: 12px;
  overflow: hidden;
  position: relative;
}

.table-body .top {
  padding: 0 0 8px 0;
  background: #fff;
  display: flex;
  justify-content: space-between;
  padding-right: 0;
}

.table-body > .table {
  margin-bottom: 10px;
}

.table-info-wrap {
  margin-bottom: -10px;
}

.table-info {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #ebeef5;
  margin-bottom: 10px;
  padding: 0 10px 0 10px;
}

.table-info:last-child {
  margin-bottom: 0;
  border-bottom: 0;
}

.table-info .left {
  margin-right: 12px;
  width: 111px;
  height: 111px;
  margin-bottom: 10px;
  position: relative;
}

.table-info .left .mini-img {
  width: 109px;
  height: 109px;
  border: 1px solid #dddddd;
}

.table-info .right {
  font-size: 12px;
  width: 200px;
  padding: 0 0 4px 0;
}

.loan-wrap {
  display: flex;
  flex-direction: column;
  display: flex;
  flex-direction: column;
  padding: 0 10px;
  font-size: 12px;
  text-align: left;
}

.loan-wrap .title.lw40 {
  width: 24px;
}

.loan-wrap .title {
  width: 48px;
  display: inline-block;
  text-align: justify;
  text-align-last: justify;
}

.operate {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.operate .link {
  font-size: 12px;
  color: #4934b2;
  cursor: pointer;
}

.custom-order ::v-deep .el-select {
  width: 100%;
}

.custom-order ::v-deep .el-date-editor {
  width: 100%;
}
.preview-area {
  overflow: hidden;
  .carousel {
    width: 600px;
    float: left;
    .el-carousel__item {
      text-align: center;
    }
    ::v-deep .el-carousel__container {
      height: 500px;
    }
    ::v-deep .el-carousel__indicators {
      display: none;
    }
    img {
      width: 500px;
      height: 500px;
    }
  }
  .preview-list {
    width: 130px;
    float: left;
    height: 500px;
    margin: 0 0 0 16px;
    overflow-y: auto;
    .preview-list-item {
      border: 1px solid #e5e5e5;
      margin: 0 8px 15px 0;
      box-sizing: border-box;
      width: 111px;
      height: 111px;
      position: relative;
      cursor: pointer;
      .preview-text {
        display: none;
        position: absolute;
        bottom: 0;
        left: 0;
        text-align: center;
        width: 100%;
        background: rgba(0, 0, 0, 0.4);
        color: #fff;
        padding: 0.05rem 0;
        font-size: 0.14rem;
        z-index: 10;
        font-size: 14px;
      }
      &:hover .preview-text {
        display: block;
      }
      &.is-active .preview-text {
        display: block;
        background: #4934b2;
      }
    }

    img {
      width: 109px;
      height: 109px;
    }
    .is-active {
      border: 1px solid #4934b2;
    }
  }
  .color-picker {
    overflow: hidden;
    margin: 16px 8px 0 0;
    ul {
      overflow: hidden;
      padding: 0px 0 0 266px;
    }
  }

  .color-picker-list li,
  .color-picker-list-hover li {
    background-color: #fff;
    width: 24px;
    height: 24px;
    border-radius: 4px;
    border: #d6d2d2 solid 1px;
    margin-left: 2px;
    padding: 1px;
    float: left;
  }
  .color-picker-list li.cur {
    border: #4934b2 solid 2px;
  }
  .color-picker-list li a,
  .color-picker-list-hover li a {
    width: 24px;
    height: 24px;
    display: table;
  }
}
.product-type {
  position: absolute;
  left: 4px;
  top: 4px;
  border-color: rgb(255, 144, 0);
  background-color: rgb(255, 144, 0);
  height: 20px;
  padding: 0 5px;
  line-height: 19px;
  color: #fff;
  font-size: 12px;
  border-radius: 5px;
}
.product-tag {
  position: absolute;
  left: 4px;
  top: 4px;
  border-color: #ff9000;
  background-color: #ff9000;
  height: 20px;
  padding: 0 5px;
  line-height: 19px;
  color: #fff;
  font-size: 12px;
  border-radius: 5px;
}
.table-menu {
  width: 100%;
  z-index: 100;
  background: #ffffff;
}
.custom-order ::v-deep .el-tabs__item.is-active {
  background: #ffffff;
}
.variantInfo {
  padding: 10px;
  margin-bottom: 20px;
  background: #e1f7f2;
}

.mr_10 {
  margin-right: 10px !important;
}

.f_gray {
  color: #919099;
}
.variantInfo .line {
  display: inline-block;
  margin: -2px 20px 0;
  width: 1px;
  height: 15px;
  background: #d8dcdf;
  vertical-align: middle;
}
.extra-image-ul > li,
.extra-image-ul > li {
  background: #eeeeee;
}
.sort-img-item {
  position: relative;
  width: 100px;
  height: 100px;
  display: inline-block;
  img {
    width: 100px;
    height: 100px;
    position: absolute;
    left: 0;
  }
}

.extra-image-ul li {
  width: 100px;
  height: 100px;
  margin-right: 8px;
  margin-bottom: 8px;
  border: 1px solid rgb(221, 221, 221);
  position: relative;
  text-align: center;
  display: inline-block;
}
.add-image-button {
  background: #ebeef5;
}
.add-image-button > p {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  line-height: 1.4;
  width: 110%;
  font-size: 20px;
}
.item-badge {
  position: absolute;
  color: rgb(255, 165, 79);
  font-weight: bold;
  font-size: 14px;
  top: 5px;
  left: 6px;
  // -ms-transform: rotate(-35deg);
  // -webkit-transform: rotate(-35deg);
  // transform: rotate(-35deg);
  -webkit-transition: 0 0.1s ease-in;
  -moz-transition: 0 0.1s ease-in;
  -o-transition: 0 0.1s ease-in;
  transition: transform 0.1s ease-in;
  z-index: 100;
}
li .wish-product-img-ope,
li .wish-product-img-ope,
li .wish-product-img-ope {
  width: calc(100% - 8px);
  padding: 1px 4px;
  background: rgb(73, 52, 178);
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 9;
  line-height: 20px;
  text-align: left;
  font-size: 12px;
  color: #ffffff;
  a {
    color: #ffffff;
  }
  .set-main {
    float: left;
    cursor: pointer;
  }
  .set-delete {
    float: right;
    cursor: pointer;
  }
}
.price-set {
  ::v-deep .el-input--suffix .el-input__inner {
    padding-right: 16px;
  }
}
</style>
